// HOLIDAY
export const REDUCER_ROUMU_SET_WORK_HOLIDAY_DATES = 'REDUCER_ROUMU_SET_WORK_HOIDAY_DATES'
export const REDUCER_ROUMU_SUB_HOLIDAY_FORM_OPEN = 'REDUCER_ROUMU_SUB_HOLIDAY_FORM_OPEN'
export const REDUCER_ROUMU_SUB_HOLIDAY_FORM_CLOSE = 'REDUCER_ROUMU_SUB_HOLIDAY_FORM_CLOSE'
export const USER_ROUMU_REGIST_SUB_HOLIDAY = 'USER_ROUMU_REGIST_SUB_HOLIDAY'

export const REDUCER_ROUMU_SET_HOLIDAY_DATES = 'REDUCER_ROUMU_SET_HOLIDAY_DATES'
//---

export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const REDUCER_SET_AUTH = 'REDUCER_SET_AUTH'
export const SYSTEM_FETCH_LOGIN_STATE = 'SYSTEM_FETCH_LOGIN_STATE'


// KENMEI
export const SYSTEM_KENMEI_LIST_INIT = 'SYSTEM_KENMEI_LIST_INIT'


//===============================================


export const REDUCER_ROUMU_UPDATE_STORE = 'REDUCER_ROUMU_UPDATE_STORE'


//================================================

export const USER_ROUMU_FORM_OPEN = 'USER_ROUMU_FORM_OPEN'
export const REDUCER_ROUMU_FORM_OPEN = 'REDUCER_ROUMU_FORM_OPEN'
export const USER_ROUMU_FORM_CLOSE = 'USER_ROUMU_FORM_CLOSE'
export const REDUCER_ROUMU_FORM_CLOSE = 'REDUCER_ROUMU_FORM_CLOSE'
export const REDUCER_ROUMU_FORM_NEXT = 'REDUCER_ROUMU_FORM_NEXT'
export const USER_ROUMU_REGIST_EVENT = 'USER_ROUMU_REGIST_EVENT'
export const REDUCER_ROUMU_SET_CURRENT_KENMEI = 'REDUCER_ROUMU_SET_CURRENT_KENMEI'

export const REDUCER_ROUMU_APPROVAL_DIALOG_OPEN = 'REDUCER_ROUMU_APPROVAL_DIALOG_OPEN'
export const REDUCER_ROUMU_APPROVAL_DIALOG_CLOSE = 'REDUCER_ROUMU_APPROVAL_DIALOG_CLOSE'

export const REDUCER_ROUMU_ALERT_DIALOG_OPEN = 'REDUCER_ROUMU_ALERT_DIALOG_OPEN'
export const REDUCER_ROUMU_ALERT_DIALOG_CLOSE = 'REDUCER_ROUMU_ALERT_DIALOG_CLOSE'

export const USER_ROUMU_APPROVAL = 'USER_ROUMU_APPROVAL'





export const SYSTEM_ROUMU_INIT = 'SYSTEM_ROUMU_INIT'
export const SYSTEM_ROUMU_GET_EVENTS = 'SYSTEM_ROUMU_GET_EVENTS'
export const REDUCER_ROUMU_SET_EVENTS = 'REDUCER_ROUMU_SET_EVENTS'

export const SYSTEM_ROUMU_GET_KENMEI_CODES = 'SYSTEM_ROUMU_GET_KENMEI_CODES'
export const REDUCER_ROUMU_SET_SELECT_DATA = 'REDUCER_ROUMU_SET_SELECT_DATA'

export const REDUCER_ROUMU_REMOVE_EVENTS = 'REDUCER_ROUMU_REMOVE_EVENTS'

export const SYSTEM_ROUMU_GET_YOSAN_COSTS = 'SYSTEM_ROUMU_GET_YOSAN_COSTS'
export const REDUCER_ROUMU_SET_YOSAN_COSTS = 'REDUCER_ROUMU_SET_YOSAN_COSTS'

export const SYSTEM_ROUMU_GET_WORK_HOLIDAY = 'SYSTEM_ROUMU_GET_WORK_HOLIDAY'
export const REDUCER_ROUMU_SET_WORK_HOLIDAY = 'REDUCER_ROUMU_SET_WORK_HOLIDAY'

//global 
export const REDUCER_APP_LOADING = 'REDUCER_APP_LOADING'


//Master
export const SYSTEM_MASTER_INIT = "SYSTEM_MASTER_INIT"
export const REDUCER_MASTER_INIT = "REDUCER_MASTER_INIT"
export const REDUCER_MASTER_SET_CLICK_KIND = "REDUCER_MASTER_SET_CLICK_KIND"
export const USER_MASTER_SEARCH = "USER_MASTER_SEARCH"
export const REDUCER_MASTER_SET_LIST = "REDUCER_MASTER_SET_LIST"
export const USER_MASTER_GET_LIST = "USER_MASTER_GET_LIST"
export const USER_MASTER_FORM_REGIST = "USER_MASTER_FORM_REGIST"
export const USER_MASTER_FORM_EDIT = "USER_MASTER_FORM_EDIT"
export const USER_MASTER_FORM_DELETE = "USER_MASTER_FORM_DELETE"
export const REDUCER_MASTER_FORM_RESET = "USER_MASTER_FORM_RESET"
export const REDUCER_MASTER_SET_FORM = "USER_MASTER_SET_FORM"
export const REDUCER_MASTER_SET_SELECT_DATA = "REDUCER_MASTER_SET_SELECT_DATA"

//Yosan
export const SYSTEM_YOSAN_INIT = "SYSTEM_YOSAN_INIT"
export const SYSTEM_YOSAN_HISTORY_INIT = "SYSTEM_YOSAN_HISTORY_INIT"
export const USER_YOSAN_HISTORY_COST_OPEN = "USER_YOSAN_HISTORY_COST_OPEN"
export const REDUCER_YOSAN_TEST = "REDUCER_YOSAN_TEST"
export const REDUCER_YOSAN_INIT = "REDUCER_YOSAN_INIT"
export const REDUCER_YOSAN_HISTORY_INIT = "REDUCER_YOSAN_HISTORY_INIT"
export const REDUCER_YOSAN_SET_TRANSITION = "REDUCER_YOSAN_TRANSITION"
export const REDUCER_YOSAN_SET_KENMEI_NAMES = "REDUCER_YOSAN_SET_KENMEI_NAMES"
export const REDUCER_YOSAN_STATE_CLEAR = "REDUCER_YOSAN_STATE_CLEAR"

//YosanList
export const SYSTEM_YOSANLIST_INIT = "SYSTEM_YOSANLIST_INIT"
export const SYSTEM_YOSANHISTORYLIST_INIT = "SYSTEM_YOSANHISTORYLIST_INIT"
export const REDUCER_YOSANLIST_INIT = "REDUCER_YOSANLIST_INIT"
export const REDUCER_YOSANHISTORYLIST_INIT = "REDUCER_YOSANHISTORYLIST_INIT"
export const USER_YOSANLIST_SEARCH = "USER_YOSANLIST_SEARCH"
export const USER_YOSANHISTORYLIST_SEARCH = "USER_YOSANHISTORYLIST_SEARCH"
export const REDUCER_YOSANLIST_FORM_CLEAR = "REDUCER_YOSANLIST_FORM_CLEAR"
export const REDUCER_YOSANHISTORYLIST_FORM_CLEAR = "REDUCER_YOSANHISTORYLIST_FORM_CLEAR"
export const REDUCER_YOSANLIST_SET_SEARCH_RESULT = "REDUCER_YOSANLIST_SET_SEARCH_RESULT"
export const REDUCER_YOSANHISTORYLIST_SET_SEARCH_RESULT = "REDUCER_YOSANHISTORYLIST_SET_SEARCH_RESULT"
export const USER_YOSANLIST_UPLOAD = "USER_YOSANLIST_UPLOAD"

export const REDUCER_SUMMARYCSV_RESULT = "REDUCER_SUMMARYCSV_RESULT"
export const REDUCER_SUMMARYCSV_CLOSE = "REDUCER_SUMMARYCSV_CLOSE"

//Global
export const REDUCER_SNACKBAR = "REDUCER_SNACKBAR"
export const REDUCER_ERROR_MESSAGE = "REDUCER_ERROR_MESSAGE"
export const USER_YOSAN_FORM_REGIST = "USER_YOSAN_FORM_REGIST"
export const USER_YOSAN_FORM_DELETE = "USER_YOSAN_FORM_DELETE"


//V2
export const SYSTEM_BIZ_HOLIDAY_INIT = "SYSTEM_BIZ_HOLIDAY_INIT"
export const REDUCER_BIZ_HOLIDAY_INIT = "REDUCER_BIZ_HOLIDAY_INIT"
export const REDUCER_BIZ_HOLIDAY_REMOVE_DATE = "REDUCER_BIZ_HOLIDAY_REMOVE_DATE"
export const USER_BIZ_HOLIDAY_REGIST = "USER_BIZ_HOLIDAY_REGIST"
export const USER_BIZ_HOLIDAY_CHANGE_YEAR = "USER_BIZ_HOLIDAY_CHANGE_YEAR"

export const SYSTEM_SUB_HOLIDAY_INIT = "SYSTEM_SUB_HOLIDAY_INIT"
export const REDUCER_SUB_HOLIDAY_INIT = "REDUCER_SUB_HOLIDAY_INIT"
export const USER_SUB_HOLIDAY_REGIST = "USER_SUB_HOLIDAY_REGIST"

export const USER_SYSTEM_CONTROLL_SUB_HOLIDAY_CLEAR = "USER_SYSTEM_CONTROLL_SUB_HOLIDAY_CLEAR"
export const USER_SYSTEM_CONTROLL_SUB_HOLIDAY_DOWNLOAD = "USER_SYSTEM_CONTROLL_SUB_HOLIDAY_DOWNLOAD"

export const SYSTEM_SYSTEMCONTROLL_ROUMU_INIT = "SYSTEM_SYSTEMCONTROLL_ROUMU_INIT"
export const REDUCER_SYSTEMCONTROLL_ROUMU_INIT = "REDUCER_SYSTEMCONTROLL_ROUMU_INIT" 

export const REDUCER_ROUMU_FORM_RESET = "REDUCER_ROUMU_FORM_RESET" 



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js